var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4286 2.57143H18.8571V0.857159C18.8571 0.383755 18.4734 0 18 0C17.5266 0 17.1428 0.383755 17.1428 0.857159V2.57143H6.85712V0.857159C6.85712 0.383755 6.47337 0 6.00001 0C5.52666 0 5.14285 0.383755 5.14285 0.857159V2.57143H2.57143C1.15127 2.57143 0 3.72269 0 5.14285V21.4286C0 22.8487 1.15127 24 2.57143 24H21.4286C22.8487 24 24 22.8487 24 21.4286V5.14285C24 3.72269 22.8487 2.57143 21.4286 2.57143ZM22.2857 21.4286C22.2857 21.902 21.9019 22.2857 21.4285 22.2857H2.57143C2.09802 22.2857 1.71427 21.902 1.71427 21.4286V10.2857H22.2857V21.4286ZM22.2857 8.57144H1.71427V5.14285C1.71427 4.66945 2.09802 4.28569 2.57143 4.28569H5.14285V5.99996C5.14285 6.47337 5.52661 6.85712 6.00001 6.85712C6.47342 6.85712 6.85717 6.47337 6.85717 5.99996V4.28569H17.1429V5.99996C17.1429 6.47337 17.5266 6.85712 18 6.85712C18.4734 6.85712 18.8572 6.47337 18.8572 5.99996V4.28569H21.4286C21.902 4.28569 22.2858 4.66945 22.2858 5.14285V8.57144H22.2857Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7278 12.2504C17.3956 11.9296 16.869 11.9296 16.5369 12.2504L10.2857 18.5015L7.4631 15.6789C7.12259 15.3501 6.57998 15.3595 6.25112 15.7C5.93029 16.0321 5.93029 16.5587 6.25112 16.8909L9.6797 20.3195C10.0144 20.6541 10.557 20.6541 10.8917 20.3195L17.7488 13.4624C18.0777 13.1219 18.0682 12.5792 17.7278 12.2504Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate1);
export default __webpack_public_path__ + "static/media/date_1.ca1c155f21fafc2bf17649510f089034.svg";
export { ForwardRef as ReactComponent };